import { useQuery_escape_hatch as useSearchProductsFromBrand } from "@faire/web-api--source/api/v2/search/products/from-brand/post-hooks";
import { ISearchMakerProductsRequest } from "@faire/web-api--source/indigofair/data/ISearchMakerProductsRequest";
import { ISearchProductsFromBrandRequest } from "@faire/web-api--source/indigofair/data/ISearchProductsFromBrandRequest";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
export var useSearchProductsFromBrandQuery = function() {
    var _useFaireDirectBrand = useFaireDirectBrand(), faireDirectBrandToken = _useFaireDirectBrand.faireDirectBrandToken, isFaireDirectActiveInLoggedOut = _useFaireDirectBrand.isFaireDirectActiveInLoggedOut;
    var request = getSearchProductsFromBrandRequest(faireDirectBrandToken);
    return useSearchProductsFromBrand(request, {
        enabled: isFaireDirectActiveInLoggedOut
    });
};
var PAGE_SIZE = 20;
var SORT_BY = ISearchMakerProductsRequest.SortBy.FEATURED;
var getSearchProductsFromBrandRequest = function(elevateBrandToken) {
    return ISearchProductsFromBrandRequest.build({
        brand_token: elevateBrandToken,
        category: undefined,
        page_number: 1,
        page_size: PAGE_SIZE,
        include_sales_paused: true,
        sort_by: SORT_BY
    });
};
